export const processPageEnglish = {
  noRunsForFilters:
    "No runs match these filters. Change People or Dates, or adjust the run selection.",
  searchProcesses: "Search processes, steps, apps or people…",
  recent: "Recently viewed",
  recentEmpty: "Processes you open will appear here.",
  groups: "Browse by process group",
  back: "Back to groups",
  results_one: "{{count}} result",
  results: "{{count}} results",
  match_name: "Matched name: {{value}}",
  match_description: "Matched description: {{value}}",
  match_step: "Matched step: {{value}}",
  match_app: "Uses {{value}}",
  match_person: "Performed by {{value}}",
  match_group: "Matched group: {{value}}",
  match_session: "Matched session: {{value}}",
  match_object: "Matched object: {{value}}",
  searchApps: "Search apps…",
  clearFilter: "Clear {{filter}} filter",
  runsSelected_one: "{{count}} case selected",
  runsSelected: "{{count}} cases selected",
  showCases_one: "Show {{count}} case",
  showCases: "Show {{count}} cases",
  searchRuns: "Search cases…",
  backToFilters: "Back to filters",
  activeFilters: "Active filters",
  runDescription: "Case description",
  selectedRuns: "Selected cases",
  whatIsRun: "What is a case?",
  runDefinition:
    "A case is one observed occurrence of a process. It groups the steps someone performed on that occasion.",
  runExample:
    "For example, researching a prospect, sending an email and updating the CRM could be one case of a sales outreach process.",
  runSelectionHelp:
    "The graph combines the cases you select. Choose one to see its steps, or several to explore patterns.",
  people: "People",
  dates: "Dates",
  showInGraph: "Show in the graph",
  typicalCases: "Typical cases",
  typicalCasesHelp: "Platonic picks the most common paths so the graph stays readable.",
  allMatchingCases: "All matching cases",
  allMatchingCasesHelp: "Every case that matches the filters, including rare branches.",
  pickedCases: "Cases I pick",
  pickedCasesHelp: "Choose specific cases from the list.",
  hiddenPicks_one: "{{count}} picked case is hidden by the filters.",
  hiddenPicks: "{{count}} picked cases are hidden by the filters.",
  choosePicks: "Choose",
  editPicks: "Edit",
  pickCases: "Pick cases",
  caseListView: "Cases to list",
  allCount: "All {{count}}",
  pickedCount: "Picked {{count}}",
  moreFilters: "More filters",
  scopeModeTypical: "Typical",
  scopeModePicked: "Picked",
  apps: "Apps",
  duration: "Duration",
  stepCount: "Step count",
  containsStep: "Contains step",
  commonPathsExampleHelp:
    "Not enough shared route evidence to show a group of cases. Showing one complete example case.",
  noCommonPathsHelp:
    "No typical paths found in these cases. Choose All matching cases to explore them.",
  turnOffCommonPaths: "Show all matching cases",
  durationFilterHelp: "Filter by case duration. Leave either bound empty for no limit.",
  stepCountHelp: "Number of executed steps, including repetitions.",
  durationUnit: "Unit",
  minutesUnit: "Minutes",
  hoursUnit: "Hours",
  minimum: "Minimum",
  maximum: "Maximum",
  noLimit: "No limit",
  invalidRange:
    "Enter non-negative bounds with minimum no greater than maximum. Step counts must be whole numbers.",
  minMinutes: "Minimum minutes",
  maxMinutes: "Maximum minutes",
  allPeople: "All people",
  allApps: "All apps",
  groupBy: "Group cases by",
  noGrouping: "No grouping",
  byPerson: "Person",
  bySession: "Session",
  collapseAll: "Collapse all",
  expandAll: "Expand all",
  selectMatchingRuns_one: "Select all {{count}} matching case",
  selectMatchingRuns: "Select all {{count}} matching cases",
  onlyRun: "Select only this case",
  only: "Only",
  plainLanguage: "Filter in plain language",
  appCount_one: "{{count}} app",
  appCount: "{{count}} apps",
  expand: "Expand graph",
  restore: "Restore details",
  averagePerRun: "Average duration per case",
  groupValues:
    "Averages across every case in each group, including cases where a step or app was not used.",
  groupStepsHelp:
    "Ranked by the largest work time differences per case. Percentages show how many cases use the step; × shows occurrences per case.",
  stepDifferences: "Step differences",
  comparisonTitle: "Comparison",
  comparisonSummary: "At a glance",
  comparisonDelta: "B − A",
  comparisonDeltaHelp: "Side B minus side A. Positive means more in B; negative means more in A.",
  comparisonCaseValues: "Actual values for these two cases, including every repeated step.",
  comparisonElapsedHelp:
    "Time from the first step starting to the last step ending, including waits.",
  comparisonMoreWork: "{{side}} spends {{time}} more working than {{other}}.",
  comparisonMoreWait: "{{side}} waits {{time}} longer between steps than {{other}}.",
  comparisonAverageFinding: "Per case, on average. Select a step below to focus it in the graph.",
  comparisonCaseFinding: "Use Step by step to see where the two cases differ.",
  comparisonNoStep: "Not used in this group",
  comparisonStepCoverage: "{{percent}}% of cases · {{occurrences}}× per case",
  comparisonShowApps: "Show all {{count}} apps",
  comparisonAppHelp: "Work time in each app. Bars use the same time scale for both sides.",
  comparisonGroupAppHelp:
    "Work time per case in each app. Bars use the same time scale for both groups.",
  compareSimplifiedHelp:
    "Graph simplification only changes the paths drawn. Comparison includes every case in scope.",
  activeTimePerRun: "Active time per case",
  compareTitle: "Compare {{name}}",
  compareQuestion: "Compare by",
  compareIntro: "Choose what to compare, preview each side, then open the combined comparison.",
  compare_duration: "By duration",
  compare_people: "By people",
  compare_period: "By time period",
  compare_runs: "Specific cases",
  compare_apps: "By apps",
  compare_processes: "Another process",
  longerShorter: "Longer vs. shorter",
  longerTypical: "Longer vs. typical",
  shorterTypical: "Shorter vs. typical",
  durationGroupsHelp:
    "Cases are split into roughly equal thirds by active work time, excluding waits.",
  emptyDurationGroups:
    "Rounded minute cutoffs leave one of these groups empty. Try a different comparison or include more cases.",
  durationSmallScope:
    "Typical comparisons need at least 3 cases. With 2 cases, choose Longer vs. shorter.",
  longerCases: "Longer cases",
  shorterCases: "Shorter cases",
  durationGroupCount_one: "{{count}} case",
  durationGroupCount: "{{count}} cases",
  activeTime: "Active time",
  durationMinutes: "{{count}} min",
  currentScope: "Cases in scope ({{count}})",
  allScope: "All available cases ({{count}})",
  scope: "Cases to compare",
  allAvailableRuns: "All cases",
  allRunsCount: "All cases ({{count}})",
  allProcessRuns: "All cases of both processes",
  periodA: "Period A",
  periodB: "Period B",
  currentScopeHelp: "Keeps your filters and chosen cases.",
  allScopeHelp: "Includes cases outside your filters and chosen cases.",
  periodScope: "To include cases outside the current date filter, choose “All cases”.",
  appScope: "Cases using both selected apps are excluded from both groups.",
  excludedApps: "{{count}} cases used both apps and were excluded.",
  personA: "Person A",
  personB: "Person B",
  appA: "App A",
  appB: "App B",
  choose: "Choose…",
  last30: "Last 30 days",
  previous30: "Previous 30 days",
  noComparison: "Choose two different, non-empty groups or cases to compare.",
  unavailable: "Could not load the comparison data. Please try again.",
  change: "Change comparison",
  aggregateMap: "All {{count}} cases",
  singleMap: "Individual case",
  averageSteps: "Steps per case",
  averageWait: "Waits between steps per case",
  averageRepeats: "Repeated steps per case",
  mapValues: "Node values show occurrences and active time per case.",
  groupMapValues: "Node values show average occurrences and active time per case.",
  mapFailed: "The map could not be laid out.",
  periodHelp:
    "Periods use case start times in your timezone. Boundary-crossing cases belong to the period in which they started.",
  processScope: "Includes all cases from both processes, regardless of page filters.",
};
